import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { filter } from 'lodash';

import { BrigadesService } from '../../brigades.service';
import { Enums } from '../../../../../../../configs/Enums';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-move-user-new-brigade-modal',
  templateUrl: './move-user-new-brigade-modal.component.html',
  styleUrls: ['./move-user-new-brigade-modal.component.scss'],
  standalone: false,
})
export class MoveUserNewBrigadeModalComponent implements OnInit {
  public errorMessage;
  public user;
  public brigadeSelected = null;
  public moveBrigadeLoading = false;
  public errorMessageCode = Enums.errorCodesMaps['BACKEND_ERROR'];
  public brigadeList = [];
  public brigadeListWithOthCurrentBrigade = [];
  public brigadeHeadNewSelected = null;
  public brigadeHeadListInBrigade;
  public title;
  public description;
  public mode;
  public currentBrigade;
  public sector;

  constructor(
    public activeModal: NgbActiveModal,
    private brigadesService: BrigadesService
  ) {}

  ngOnInit() {
    if (['moveUser', 'moveBrigadeHead', 'moveBrigadeHeadAndDrop'].indexOf(this.mode) > -1) {
      this.getBrigades();
    }

    if (this.mode && this.mode === 'moveBrigadeHead') {
      this.brigadeHeadListInBrigade = this.brigadeHeadListInBrigade.map((worker) => {
        worker.full_name = worker.employee.full_name;
        return worker;
      });
    }
  }

  private getBrigades() {
    this.moveBrigadeLoading = true;
    this.brigadesService.getBrigadesTruncated({ sector_id: this.sector.sector_id }).subscribe(
      (response) => {
        this.brigadeList = response['data'];
        this.filterBrigades();
        this.moveBrigadeLoading = false;
      },
      (error) => {
        this.moveBrigadeLoading = false;
      }
    );
  }

  private filterBrigades() {
    if (!this.currentBrigade) {
      return;
    }

    this.brigadeListWithOthCurrentBrigade = filter(this.brigadeList, (brigade) => {
      return brigade.id !== this.currentBrigade.id;
    });
  }

  public onChangeSelectedNewBrigadeHead(selected) {
    this.brigadeHeadNewSelected = selected;
  }

  public onChangeSelectedMoveBrigade(selected) {
    this.brigadeSelected = selected;
  }

  public onMoveUserNewBrigade() {
    switch (this.mode) {
      case 'moveUser':
        if (!this.currentBrigade) {
          this.onMoveUserNewBrigadeWithOutBrigadeContext();
        } else {
          this.onMoveUserNewBrigadeWithBrigadeContext();
        }
        break;
      case 'moveBrigadeHead':
        this.onMoveBrigadeHeadUserNewBrigade();
        break;
      case 'moveBrigadeHeadAndDrop':
        this.onMoveBrigadeHeadUserNewBrigadeAndDropBrigade();
        break;
    }
  }

  public onMoveUserNewBrigadeWithOutBrigadeContext() {
    this.moveUser({
      brigade: this.brigadeSelected.id,
      mounter: this.user.u_id,
      new_head: null,
      sector_id: this.sector.sector_id
    });
  }

  public onMoveUserNewBrigadeWithBrigadeContext() {
    this.moveUser({
      brigade: this.brigadeSelected.id,
      mounter: this.user.u_id,
      new_head: null,
      sector_id: this.sector.sector_id
    });
  }

  public onMoveBrigadeHeadUserNewBrigade() {
    this.moveUser({
      brigade: this.brigadeSelected.id,
      mounter: this.user.u_id,
      new_head: this.brigadeHeadNewSelected.u_id,
      sector_id: this.sector.sector_id
    });
  }

  public onMoveBrigadeHeadUserNewBrigadeAndDropBrigade() {
    this.moveUser({
      brigade: this.brigadeSelected.id,
      mounter: this.user.u_id,
      new_head: null,
      sector_id: this.sector.sector_id
    });
  }

  private moveUser(data) {
    this.moveBrigadeLoading = true;
    this.brigadesService.moveUserNewBrigadeBrigade(data).subscribe(
      (response) => {
        this.moveBrigadeLoading = false;
        this.activeModal.close();
      },
      (error) => {
        this.errorMessage = Enums.errorCodes[this.errorMessageCode];
        this.moveBrigadeLoading = false;
      }
    );
  }
}
